export default {
    ...require("./en/applepay.json"),
    ...require("./en/bank.json"),
    ...require("./en/banktransfer.json"),
    ...require("./en/barter.json"),
    ...require("./en/card.json"),
    ...require("./en/cryptocurrency"),
    ...require("./en/eNaira.json"),
    ...require("./en/fawrypay.json"),
    ...require("./en/googlepay.json"),
    ...require("./en/internet-banking.json"),
    ...require("./en/mobile-money.json"),
    ...require("./en/mpesa.json"),
    ...require("./en/nqr.json"),
    ...require("./en/migo.json"),
    ...require("./en/paga.json"),
    ...require("./en/payattitude.json"),
    ...require("./en/paypal.json"),
    ...require("./en/plaid.json"),
    ...require("./en/qr.json"),
    ...require("./en/ussd.json"),
    ...require("./en/voucher.json"),
    ...require("./en/wechat.json"),
    ...require("./en/ui.json"),
    ...require("./en/paymenterrors.json"),
    ...require("./en/init.json"),
    ...require("./en/instructions.json"),
    ...require("./en/paymentoptions.json"),
    ...require("./en/opay.json"),
    ...require("./en/capitec.json"),
};